import React from "react";

//Importar íconos de Material UI.
import { Delete, Mic, InsertDriveFile } from '@mui/icons-material/';

// *******Componenete que renderiza la vista previa mini del los contenidos multimedia arrastrados o seleccionados en el chat********.

const FilePreviewMini = ({ typeFile, filesSelected, handleFilePreviewSelected, setFilesSelected, fileSelected, urlFile }) => {

    const handleDeleteFile = (fileName) => {//Función para eliminar el archivo de imagen miniatura seleccionado.
        const updatedFiles = filesSelected.filter(file => file.name !== fileName);
        setFilesSelected(updatedFiles);
    };

    return (
        <>
            {filesSelected.length > 0 && filesSelected.map(file => {
                const fileType = file.type.split('/')[0]; // Obtener el tipo de archivo (ej: 'image', 'audio', 'application')
                const isImage = fileType === 'image';
                const isAudio = fileType === 'audio';
                const isPdf = file.type.split('/')[1] === "pdf";

                // Filtrar por tipo de archivo y renderizar en consecuencia
                if ((typeFile === "image" && isImage) ||
                    (typeFile === "audio" && isAudio) ||
                    (typeFile === "document" && isPdf)) {

                    return (
                        <div key={file.lastModified} onClick={() => handleFilePreviewSelected(file)} 
                        className="container-img-preview__mini--individual"
                        style={{ border: file.name === fileSelected ? "1px solid var(--profile-operator-border-color)" : "" }}>
                           
                                <div className="container-img-preview__mini--btn--delete">
                                    <Delete sx={{ fontSize: "20px" }} onClick={() => handleDeleteFile(file.name)} />
                                </div>
                            
                            {isImage && <img src={URL.createObjectURL(file) || urlFile} 
                            alt="Vista previa del archivo seleccionado" style={{ maxWidth: '100%', maxHeight: '100%' }} />}
                            {isAudio && <Mic />}
                            {isPdf && <InsertDriveFile />}
                        </div>
                    );
                } else {
                    return null;
                }
            })}

        </>
    );
};

export default FilePreviewMini;
